// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root  {
    --ice-balck-background: rgb(234, 251, 248);
    --black-05-background: rgba(0, 0, 0, 0.5); 
    --eeeeef-background: #eeeeef; 
    --f1-background:#f1f1f1;
    --f5-background:#f5f5f5;
    --e0e0e0-background: #e0e0e0;
    --_030303-color:#030303;
    --f5f5f538-background: #f5f5f538;
    --f5-chatAdmin-background:#ffffff;
    --f5-chatAdmin-body-background:#ffffff;
    --white-background: #ffffff;
    --_646e8a-color:#646e8a;
    --_16c098-background:#16c098;
    --_8a-color:#8a8a8a;
    --f4-background:#f4f4f4;
    --f4-chatAdmin-background:#f4f4f4;
    --_10a37f-background:#10a37f;
    --_00000036-border:#00000036;
    --_000000cc-background:#000000cc;
    --_073f31-background:#073f31;
    --_d7-background:#d7d7d7;
    --_5d-color:#5d5d5d;
    --_16c09821-background:#16c09821;
    --_0000000a-background: #0000000a;
    --fe-background:#fefefe;
    --f1f1f145-background:#f1f1f145;
    --efefef-background:#efefef;
    --_00000080-background:#00000080;
    --_FFFFFF80-background:#FFFFFF60;
    --_00000020-background:#00000020;
    --ed-background:#ededed;
    --_0a785d6d-background:#0a785d6d;
    --e6fff9-background:#e6fff9;
    --_1e-color:#1e1e1e;
    --f9-background:#f9f9f9;
    --_3c3a3a-color:#3c3a3a;
    --black-color:black;
    --_67-color:#676767;
    --ececf1-background:#ececf1;
    --f5f5f9-background:#f5f5f9;
    --ea-background:#eaeaea;
    --d9d9e3-border:#d9d9e3;
    --fa-background:#fafafa;
    --_3-color:#333333;
    --_3a-color: #3a3a3a;
    --_71-color:#717171;

    --_b4-color:#b4b4b4;
    --_0000001a-border:#0000001a; 
    --_00000008-border:#00000008; 
    --_00000000-border:#00000000;
    --_0d-color:#0d0d0d;
    --_00000001-background:#00000001; 
    --ececf1-border:#ececf1;
    --_c1-border:#c1c1c1;
    --_3a-background:#3a3a3a;
    --white-color:white;
    --_e6-color:#e6e6e6;
    --_52525261-background:#52525261; 
    --_f5f5f569-background:#f5f5f569;
    --cdece445-background: #cdece445;
    --e5-border:#e5e5e5;
    --16c09829-background: #cdece445;
    --16C097-fill: #16C097;
    --_16c0982e-background:#16c0982e; 
    --_223f39-color:#223f39;
    --e4fff9-background:#e4fff9;
    --f5-border:#f5f5f5;
    --_38343d-color:#38343d;
    --_75-color: #757575;
    --b40e1b-color:#b40e1b;
    --_00000033-background:#00000033;
    --_9c9d9f-color:#9c9d9f;
    --_353740-fill: #353740;
    --969595-fill: #969595;

    --7c3aed-background: #7c3aed;
    --111827-background: #111827; 
    --f9fafb-background: #f9fafb; 
    --5d81f5-background: #5d81f5; 
    --3b82f6-background: #3b82f6; 
    --1d4ed8-background: #1d4ed8; 
    --f0fdfa-background: #f0fdfa; 
    --34d399-background: #34d399; 
    --fafbfc-background: #fafbfc; 
    --10b981-background: #10b981; 
    --059669-background: #059669; 
    --196353-background: #196353; 
    --green: #0f0;
    --cyan: #0ff;
    --green-again: #0f0;
    --A8A8A859-background: #A8A8A859; 
    --_233f39-background : #233f39;
    --_122521-background: #122521;
    --f3-background:#f3f3f3;
    --dc3545-background:#dc3545;
    --c-background:#cccccc;
    --ffffffdb-background:#ffffffdb; 
    --_0c8e6d-background:#0c8e6d;
    --_6e6e80-background:#6e6e80;
    --_5a5a67-background:#5a5a67;
    --_0d8b6d-background: #0d8b6d;
    --e9e9e96d-background:#e9e9e96d;
    --_0b745a-background:#0b745a;
    --b30634-background:#b30634;
    --_6f6f81-background:#6f6f81;
    --_10a37e6a-background:#10a37e6a;
    --db-background:#dbdbdb;
    --cf-background:#cfcfcf;
    --_223f39-background:#223f39;
    --f3f4f6-background:#f3f4f6;
    --f6-background:#f6f6f6;
    --e2-background:#e2e2e2;
    --_46-background:#464646;
    --e7-background:#e7e7e7;
    --e6-background:#e6e6e6;
    --f8f9fa-background:#f8f9fa;
    --d9-background:#d9d9d9;
    --_00000066-background:#00000066;
    --_c9-background:#c9c9c9;
    --_11a380-background:#11a380;
    --_0c6d56-background:#0c6d56;
    --d8ffea-background:#d8ffea;
    --effff6-background:#effff6;
    --f9fbff-background:#f9fbff;
    --f0f2f8-background:#f0f2f8;
    --ff5c5c-background:#ff5c5c;
    --_2b0e50-background:#2b0e50;
    --_c2f2d3-background:#c2f2d3;
    --_9bd8b1fd-background:#9bd8b1fd;
    --f2c6c2-background:#f2c6c2;
    --f2cfc2-background:#f2cfc2;
    --f2e3c2-background:#f2e3c2;
    --c2d8f2-background:#c2d8f2;
    --d7c5f6-background:#d7c5f6;
    --f0c2f2-background:#f0c2f2;
    --ef0-background:#ef0;
    --dcfce7-background: #dcfce7; 
    --4CAF50-background: #4CAF50; 
    --45a049-background: #45a049; 
    --f8f8f8-background: #f8f8f8; 
    --f7f7f9-background: #f7f7f9; 
    --4a4a4a-background: #4a4a4a; 
    --blue_black-04-background: rgba(0, 163, 163, 0.04);
    --9e9e9e-background: #9e9e9e; 
    --2563eb-background: #2563eb; 
    --5f64f8-background: #5f64f8;
    --5054d9-background: #5054d9;
    --ff7a59-background: #ff7a59;
    --ee7a01-background: #ee7a01;
    --ffa927-background: #ffa927;
    --27a768-background: #27a768;
    --3cb077-background: #3cb077;
    --a14689-background: #a14689;
    --a24689-background: #a24689;
    --2ad348-background: #2ad348;
    --5df978-background: #5df978;
    --e0f2fe-background: #e0f2fe;
    --fff6d4-background: #fff6d4;
    --f5f5f538-background-hover: #f5f5f538;

    --622fae-color: #622fae;
    --6d6d6d-color: #6d6d6d;
    --202020-color: #202020; 
    --595959-color: #595959; 
    --f59e0b-color: #f59e0b; 
    --334155-color: #334155; 
    --94a3b8-color: #94a3b8; 
    --1e293b-color: #1e293b; 
    --white-stastHeader-color: rgba(255, 255, 255, 0.9);
    --059669-color: #059669; 
    --64748b-color: #64748b; 
    --0070f3-color: #0070f3; 
    --2e7d32-color: #2e7d32; 
    --_16c098-color:#16c098;
    --27272a-color: #27272a; 
    --92959865-color: #92959865; 
    --_073f31-color:#073f31;
    --_6-color:#666666;
    --_2-color:#222222;
    --8a0300-color: #8a0300; 
    --c5221f-color: #c5221f; 
    --ff5500-color: #ff5500; 
    --ff9d00-color: #ff9d00; 
    --009f7a-color: #009f7a; 
    --7b7575-color: #7b7575;
    --red-notification-color: rgb(253, 71, 71);
    --888-contacts-color: #888888;
    --292a2b-color: #292a2b;
    --aaa-color:#aaa;
    --_9-color:#999999;
    --_18181b-color:#18181b;
    --_82-color:#828282;
    --_1e0045-color:#1e0045;
    --_2ebc89-color:#2ebc89;
    --_92959858-color:#92959858;
    --_1d-color:#1d1d1d;
    --ec-color:#ececec;
    --_4f5660-color:#4f5660;
    --_807d7d-color:#807d7d;
    --_22222268-color:#22222268;
    --_2222226d-color:#2222226d;
    --_09090b-color:#09090b;
    --_232222-color:#232222;
    --_71717a-color:#71717a;
    --_48-color:#484848;
    --_9b-color:#9b9b9b;
    --_7e-color:#7e7e7e;
    --_292d32-color:#292d32;
    --_8e8eb7-color:#8e8eb7;
    --_929598-color:#929598;
    --_374151-color:#374151;
    --_494e54-color:#494e54;
    --_1f184b-color:#1f184b;
    --_2a2e32-color:#2a2e32;
    --_264f88-color:#264f88;
    --_808487-color:#808487;
    --_63-color:#636363;
    --_5c6c74-color:#5c6c74;
    --_0c1421-color:#0c1421;
    --_8897ad-color:#8897ad;
    --red-color:red;
    --b5b7c0-color:#b5b7c0;
    --_233f39-color : #233f39;
    --d0004b-color:#d0004b;
    --_3d3c42-color:#3d3c42;
    --_838485-color:#838485;
    --a6-color:#a6a6a6;
    --_00000035-color:#00000035;
    --_22024b-color:#22024b;
    --ff4d4f-color:#ff4d4f;
    --_084437-color:#084437;
    --btn-chat-background: trasparent;
    --16a34a-color: #16a34a; 
    --ef4444-color: #ef4444; 
    --dc2626-color: #dc2626; 
    --B0B0B0-color: #B0B0B0; 
    --00a3a3-color: #00a3a3; 
    --6b7280-color: #6b7280; 
    --9ca3af-color: #9ca3af; 
    --818181-color: #818181;
    --white-unic-color: #FFF;
    --292929-color: #292929;
    --8C90A2-color: #8C90A2;


    --e5e7eb-border: #e5e7eb;
    --cecece-border: #cecece; 
    --f8fafc-border: #f8fafc;
    --f1f5f9-border: #f1f5f9;
    --e2e8f0-border: #e2e8f0;
    --grayAccountSettings-border : rgba(228, 228, 228, 0.792);
    --C11515-color: #C11515;
    --B3B3B3-border: #B3B3B3; 
    --a194b7-border: #a194b7; 
    --ad8caf-border: #ad8caf; 
    --8c9caf-border: #8c9caf; 
    --8caf98-border: #8caf98; 
    --b6ab92-border: #b6ab92; 
    --af8f8c-border: #af8f8c; 
    --eaecf0-border:#eaecf0;
    --ccc-border:#ccc;
    --eb-border:#ebebeb;
    --_11a3812c-border:#11a3812c;
    --df-border:#dfdfdf;
    --ced4da-border:#ced4da;
    --_10a37f-border: #10a37f;
    --ca-border:#cacaca;
    --dc-boder:#dcdcdc;
    --cb-border:#cbcbcb;
    --_6f6f81-border:#6f6f81;
    --e3-border:#e3e3e3;
    --ef-border:#efefef;
    --e0e3e6-border:#e0e3e6;
    --e8-border:#e8e8e8;
    --_264f88-border:#264f88;
    --c3-border:#c3c3c3;
    --e0-border:#e0e0e0;
    --white-border:#ffffff;
    --_c9-border:#c9c9c9;
    --f0-border:#f0f0f0;
    --d8-border:#d8d8d8;
    --e-border:#eeeeee;
    --_11a3813c-border:#11a3813c;
    --_0000001d-border:#0000001d;
    --_0000002b-border:#0000002b;
    --11a38138-border: #11a38138;
    --cbd5e1-border: #cbd5e1;
    --dddddd-border: #dddddd; 
    --00000052-border: #00000052;



    --ac-shadow:#acacac; 
    --customDateInput-shadow: rgba(0, 123, 255, 0.2); 
    --_00000008-shadow:#00000008; 
    --_00000000-shadow:#00000000;
    --_00000026-shadow:#00000026;
    --_00000033-shadow:#00000033;
    --_0000001a-shadow:#0000001a; 
    --black-005-shadow: rgba(0, 0, 0, 0.05); 
    --black-12901-shadow: rgba(16, 185, 129, 0.1); 
    --black-12902-shadow: rgba(16, 185, 129, 0.2); 
    --green-12003-shadow: rgba(16, 185, 129, 0.3); 




}


[data-theme="dark"] {
    --ice-balck-background: rgb(15, 45, 43);
    --black-05-background: rgba(255, 255, 255, 0.12);
    --eeeeef-background: #1c1c1e; 
    --f1-background: #1a1a1a;
    --f5-background: #1f1e1e;
    --e0e0e0-background: #e0e0e0;
    --_030303-color:#bdbdbd;
    --f5f5f538-background: #ffffff1A;
    --f5-chatAdmin-background:#1A1A1A;
    --f5-chatAdmin-body-background:#212121;
    --white-background: #121212;
    --_646e8a-color: #a0abc8;
    --_16c098-background: #0e5f4f;
    --_9b-color:#bfbfbf;
    --_8a-color: #e0e0e0;
    --f4-background: #1e1e1e;
    --f4-chatAdmin-background:#F4F4F41C;
    --_10a37f-background: #0b5e4a;
    --_00000036-border: rgba(255, 255, 255, 0.15);
    --_000000cc-background: rgba(255, 255, 255, 0.2);
    --_073f31-background: #0a5a43;
    --_d7-background: #2d2d2d;
    --_5d-color: #cccccc;
    --_073f31-color: #7ed9b1;
    --_16c09821-background: rgba(38, 210, 182, 0.2);
    --_16c098-color: #5ce0c4;
    --_0000000a-background: rgba(255,255,255,0.4);
    --fe-background: #121212;
    --f1f1f145-background: #1e1e1e45;
    --efefef-background: #2a2a2a;
    --_00000080-background: rgba(255, 255, 255, 0.5);
    --ed-background: #3a3a3a;
    --_0a785d6d-background: #0a785dad;
    --e6fff9-background: #0e3c36;
    --_1e-color: #ffffff;
    --f9-background: #060606;
    --_3c3a3a-color: #c3c5c5;
    --black-color: white;
    --_67-color: #b3b3b3;
    --ececf1-background: #2c2c2e;
    --ea-background: #1e1e1e;
    --d9d9e3-border: #3a3a45;
    --_6-color: #c0c0c0;
    --fa-background: #1a1a1a;
    --_3-color: #e0e0e0;
    --_3a-color: #e3e3e3;
    --_71-color: #c0c0c0;
    --_b4-color-dark: #e0e0e0;
    --_0000001a-border: #ffffffe6;
    --_00000008-border: #ffffffed;
    --_00000000-border: #ffffffff;
    --_0d-color: #eaeaea;
    --_00000001-background: #ffffff0a;
    /* --ececf1-border: rgba(255, 255, 255, 0.2); */
    --ececf1-border: rgb(58 56 56 / 20%);
    --_c1-border: rgba(255, 255, 255, 0.15);
    --_3a-background: #b0b0b0;
    --white-color:black;
    --_e6-color: #f0f0rgb(51, 51, 51)
    --_52525261-background: rgba(255, 255, 255, 0.5);
    --_f5f5f569-background: rgba(40, 40, 40, 0.41);
    --cdece445-background: rgba(25, 50, 40, 0.27);
    --_2-color: #e0e0e0;
    --e5-border: #2a2a2a;
    --16c09829-background: #16c09829;
    --16C097-fill: #0e685d;
    --_16c0982e-background: rgba(102, 255, 224, 0.18);
    --_223f39-color: #a8ffde;
    --_0000001a-shadow: #2221211a;
    --e4fff9-background: #1a3c36;
    --f5-border: #3a3a3a;
    --_38343d-color: #d6d6d6;
    --_75-color: #dddddd;
    --b40e1b-color: #ff4c4c;
    --_ffffff33-background: #ffffff33; 
    --_9c9d9f-color: #c0c1c3;
    --_353740-fill: #d1d2d7;
    --969595-fill: #CCCCCC;




    --622fae-color: #5b21b6;
    --7c3aed-background: #5b21b6; 
    --111827-background: #0f172a; 
    --9e9e9e-background: #2a2a2a; 
    --f9fafb-background: #0f172a; 
    --5d81f5-background: #3b50d6; 
    --3b82f6-background: #2563eb; 
    --1d4ed8-background: #1e40af; 
    --f0fdfa-background: #134e4a; 
    --fafbfc-background: #0f172a; 
    --10b981-background: #047857; 
    --059669-background: #065f46; 
    --196353-background: #0f3f36; 
    --green: #0c8e6d;  
    --cyan: #088a8a;   
    --green-again: #0c8e6d;
    --A8A8A859-background: #FFFFFF59;
    --_233f39-background: #1b2d2c; 
    --_122521-background: #0a1615;
    --f3-background: #1e1e1e;
    --dc3545-background: #a72a30;
    --c-background: #444444;
    --ffffffdb-background: rgba(255, 255, 255, 0.15);
    --_0c8e6d-background: #085b43;
    --_6e6e80-background: #4a4a59;
    --_5a5a67-background: #3f3f49;
     --f5f5f9-background:#333339;
    --_0d8b6d-background: #086241;
    --e9e9e96d-background: rgba(233, 233, 233, 0.1);
    --_0b745a-background: #074a39;
    --b30634-background: #7a0224;
    --_6f6f81-background: #474758;
    --_10a37e6a-background: rgba(16, 163, 126, 0.3);
    --db-background: #333333;
    --cf-background: #2f2f2f;
    --_223f39-background: #1a2b29;
    --f3f4f6-background: #252525;
    --f6-background: #2a2a2a;
    --e2-background: #282828;
    --_46-background: #1c1c1c;
    --e7-background: #2f2f2f;
    --e6-background: #2d2d2d;
    --f8f9fa-background: #1a1a1a;
    --d9-background: #3a3a3a;
    --_00000066-background: rgba(0, 0, 0, 0.7);
    --_c9-background: #5e5e5e;
    --_11a380-background: #0d6a5b;
    --_0c6d56-background: #0a4c3f;
    --d8ffea-background: #16432b;
    --effff6-background: #192921;
    --f9fbff-background: #1c2229;
    --f0f2f8-background: #21262d;
    --ff5c5c-background: #b94141;
    --_2b0e50-background: #180b2e;
    --_c2f2d3-background: #2a4d3f;
    --_9bd8b1fd-background: rgba(155, 216, 177, 0.3);
    --f2c6c2-background: #663c3a;
    --f2cfc2-background: #6a403c;
    --f2e3c2-background: #6f5c3a;
    --c2d8f2-background: #3d4d66;
    --d7c5f6-background: #4a3a6a;
    --f0c2f2-background: #6a3a6f;
    --ef0-background: #53602e;
    --btn-chat-background: #666666;
    --dcfce7-background: #166534; 
    --34d399-background: #065f46; 
    --4CAF50-background: #357a38; 
    --45a049-background: #2e7031; 
    --f8f8f8-background: #2a2a2a; 
    --f7f7f9-background: #2c2c2e; 
    --4a4a4a-background: #d9d9d9; 
    --blue_black-04-background: rgba(0, 163, 163, 0.15); 
    --2563eb-background: #1e40af; 
    --5f64f8-background: #3b3ff8; 
    --5054d9-background: #3a3e9f; 
    --ff7a59-background: #cc6247; 
    --ee7a01-background: #b06300; 
    --ffa927-background: #b37f1a; 
    --27a768-background: #1e7c52; 
    --3cb077-background: #2c8b64; 
    --a14689-background: #7a3265; 
    --a24689-background: #883471; 
    --2ad348-background: #1e8a35; 
    --5df978-background: #3b9f55; 
    --fff6d4-background: #4b4a3a;
    --f5f5f538-background-hover: rgba(255, 255, 255, 0.07);

    --6d6d6d-color: #E0E0E0;
    --202020-color: #e5e7eb; 
    --595959-color: #d1d5db; 
    --f59e0b-color: #fbbf24; 
    --16a34a-color: #4ade80; 
    --334155-color: #e2e8f0; 
    --94a3b8-color: #e2e8f0; 
    --1e293b-color: #cbd5e1; 
    --white-stastHeader-color: rgba(24, 24, 27, 0.9); 
    --059669-color: #6ee7b7;
    --64748b-color: #cbd5e1;
    --0070f3-color: #3399ff; 
    --2e7d32-color: #1b5e20; 
    --grayAccountSettings-border: rgba(100, 100, 100, 0.6);
    --27272a-color: #3f3f46; 
    --C11515-color: #e94e4e; 
    --B3B3B3-border: #5a5a5a; 
    --92959865-color: rgba(200, 200, 200, 0.2);
    --8a0300-color: #d94c47; 
    --c5221f-color: #e35b57; 
    --ff5500-color: #ff8a4c; 
    --ff9d00-color: #ffb84d; 
    --009f7a-color: #1ad1a3; 
    --7b7575-color: #BEBEBE;
    --red-notification-color: rgb(255, 100, 100);
    --888-contacts-color: #CCCCCC;
    --292a2b-color: #f1f1f1;
    --aaa-color: #666666;
    --_9-color: #7a7a7a;
    --_18181b-color: #c9c9c9;
    --_82-color: #a3a3a3;
    --_1e0045-color: #3a2a6a;
    --_2ebc89-color: #1c8f68;
    --_92959858-color: rgba(146, 149, 152, 0.35);
    --_1d-color: #dcdcdc;
    --ec-color: #2a2a2a;
    --_4f5660-color: #9a9fa7;
    --_807d7d-color: #757575;
    --_22222268-color: rgba(34, 34, 34, 0.4);
    --_2222226d-color: rgba(34, 34, 34, 0.43);
    --_09090b-color: #e5e5e5;
    --_232222-color: #dddddd;
    --_71717a-color: #b0b0bb;
    --_48-color: #a5a5a5;
    --_7e-color: #a3a3a3;
    --_292d32-color: #c4c7cc;
    --_8e8eb7-color: #b1b3c8;
    --_929598-color: #b5b6b7;
    --_374151-color: #a0a7b4;
    --_494e54-color: #9a9fa6;
    --_1f184b-color: #7c71a2;
    --_2a2e32-color: #a3a6a8;
    --_264f88-color: #1d2a5d;
    --_808487-color: #8e9194;
    --_63-color: #a3a3a3;
    --_5c6c74-color: #7c8a91;
    --_0c1421-color: #1c2232;
    --_8897ad-color: #9aa3b7;
    --red-color: #ff6b6b;
    --b5b7c0-color: #737683;
    --_233f39-color: #1c2d2a;
    --d0004b-color: #a0003a;
    --_3d3c42-color: #a3a6a8;
    --_838485-color: #7a7a7d;
    --a6-color: #8c8c8c;
    --_00000035-color: rgba(0,0,0,0.5);
    --_22024b-color: #1e1a3a;
    --ff4d4f-color: #d44c4f;
    --_084437-color: #4dbf9e;
    --ef4444-color: #f87171; 
    --dc2626-color: #f87171; 
    --B0B0B0-color: #d4d4d8; 
    --00a3a3-color: #33cccc; 
    --6b7280-color: #d1d5db; 
    --9ca3af-color: #e5e7eb; 
    --00000052-border: rgba(0, 0, 0, 0.32); 
    --818181-color: #c1c1c1;
    --white-unic-color: #FFF;
    --292929-color: #d1d5db; 
    --8C90A2-color: #cbd5e1; 



    --e5e7eb-border: #374151; 
    --f8fafc-border: #475569; 
    --f1f5f9-border: #33
    --e2e8f0-border: #4a5568;
    --a194b7-border: #c7bbde; 
    --ad8caf-border: #dabbdc; 
    --8c9caf-border: #b7c7de; 
    --8caf98-border: #b7dbc4; 
    --b6ab92-border: #d9cfb6; 
    --af8f8c-border: #d4b3b0; 
    --11a38138-border: #11a38166;
    --eaecf0-border: #2a2a2a;
    --ccc-border: #444444;
    --eb-border: #3a3a3a;
    --_11a3812c-border: rgba(17, 163, 129, 0.18);
    --df-border: #383838;
    --ced4da-border: #3a3a3a;
    --_10a37f-border: #0b735e;
    --ca-border: #3a3a3a;
    --dc-boder: #3a3a3a;
    --cb-border: #3a3a3a;
    --_6f6f81-border: #494952;
    --e3-border: #3b3b3b;
    --ef-border: #2e2e2e;
    --e0e3e6-border: #2f2f2f;
    --e8-border: #3c3c3c;
    --_264f88-border: #1a2b58;
    --c3-border: #4a4a4a;
    --e0-border: #3d3d3d;
    --white-border: #222222;
    --_c9-border: #565656;
    --f0-border: #292929;
    --d8-border: #393939;
    --e-border: #3a3a3a;
    --_11a3813c-border: rgba(17, 163, 129, 0.24);
    --_0000001d-border: rgba(0, 0, 0, 0.12);
    --_0000002b-border: rgba(0, 0, 0, 0.17);
    --cbd5e1-border: #4b5563; 
    --cecece-border: #4b5563; 
    --dddddd-border: #444444; 





    --ac-shadow: #1a1a1a; 
    --customDateInput-shadow: rgba(0, 123, 255, 0.2); 
    --black-005-shadow: rgba(255, 255, 255, 0.08); 
    --_00000008-shadow: #00000008;
    --_00000000-shadow: #00000000;
    --_00000026-shadow: #00000026;
    --_00000033-shadow: #00000033;
    --black-12901-shadow: rgba(16, 185, 129, 0.2); 
    --green-12003-shadow: rgba(5, 150, 105, 0.15); 
    --black-12902-shadow: rgba(5, 150, 105, 0.1);




}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;IACI,0CAA0C;IAC1C,yCAAyC;IACzC,4BAA4B;IAC5B,uBAAuB;IACvB,uBAAuB;IACvB,4BAA4B;IAC5B,uBAAuB;IACvB,gCAAgC;IAChC,iCAAiC;IACjC,sCAAsC;IACtC,2BAA2B;IAC3B,uBAAuB;IACvB,4BAA4B;IAC5B,mBAAmB;IACnB,uBAAuB;IACvB,iCAAiC;IACjC,4BAA4B;IAC5B,4BAA4B;IAC5B,gCAAgC;IAChC,4BAA4B;IAC5B,wBAAwB;IACxB,mBAAmB;IACnB,gCAAgC;IAChC,iCAAiC;IACjC,uBAAuB;IACvB,+BAA+B;IAC/B,2BAA2B;IAC3B,gCAAgC;IAChC,gCAAgC;IAChC,gCAAgC;IAChC,uBAAuB;IACvB,gCAAgC;IAChC,2BAA2B;IAC3B,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;IAC3B,2BAA2B;IAC3B,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;;IAEnB,mBAAmB;IACnB,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,mBAAmB;IACnB,gCAAgC;IAChC,uBAAuB;IACvB,oBAAoB;IACpB,wBAAwB;IACxB,mBAAmB;IACnB,mBAAmB;IACnB,gCAAgC;IAChC,gCAAgC;IAChC,gCAAgC;IAChC,mBAAmB;IACnB,gCAAgC;IAChC,sBAAsB;IACtB,gCAAgC;IAChC,uBAAuB;IACvB,2BAA2B;IAC3B,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;IACpB,sBAAsB;IACtB,gCAAgC;IAChC,uBAAuB;IACvB,uBAAuB;IACvB,sBAAsB;;IAEtB,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,gCAAgC;IAChC,8BAA8B;IAC9B,6BAA6B;IAC7B,uBAAuB;IACvB,2BAA2B;IAC3B,sBAAsB;IACtB,+BAA+B;IAC/B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,6BAA6B;IAC7B,+BAA+B;IAC/B,4BAA4B;IAC5B,2BAA2B;IAC3B,4BAA4B;IAC5B,gCAAgC;IAChC,uBAAuB;IACvB,uBAAuB;IACvB,4BAA4B;IAC5B,2BAA2B;IAC3B,uBAAuB;IACvB,uBAAuB;IACvB,wBAAwB;IACxB,uBAAuB;IACvB,uBAAuB;IACvB,2BAA2B;IAC3B,uBAAuB;IACvB,gCAAgC;IAChC,wBAAwB;IACxB,4BAA4B;IAC5B,4BAA4B;IAC5B,2BAA2B;IAC3B,2BAA2B;IAC3B,2BAA2B;IAC3B,2BAA2B;IAC3B,2BAA2B;IAC3B,4BAA4B;IAC5B,4BAA4B;IAC5B,gCAAgC;IAChC,2BAA2B;IAC3B,2BAA2B;IAC3B,2BAA2B;IAC3B,2BAA2B;IAC3B,2BAA2B;IAC3B,2BAA2B;IAC3B,qBAAqB;IACrB,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,mDAAmD;IACnD,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,sCAAsC;;IAEtC,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,mDAAmD;IACnD,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,2BAA2B;IAC3B,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,0CAA0C;IAC1C,6BAA6B;IAC7B,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;IACvB,2BAA2B;IAC3B,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;IACvB,uBAAuB;IACvB,2BAA2B;IAC3B,2BAA2B;IAC3B,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,eAAe;IACf,sBAAsB;IACtB,yBAAyB;IACzB,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,kBAAkB;IAClB,2BAA2B;IAC3B,uBAAuB;IACvB,sBAAsB;IACtB,uBAAuB;IACvB,iCAAiC;IACjC,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,wBAAwB;IACxB,uBAAuB;IACvB,uBAAuB;;;IAGvB,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;IACxB,yDAAyD;IACzD,uBAAuB;IACvB,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;IACxB,uBAAuB;IACvB,iBAAiB;IACjB,mBAAmB;IACnB,4BAA4B;IAC5B,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,wBAAwB;IACxB,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,wBAAwB;IACxB,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;IACtB,oBAAoB;IACpB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,wBAAwB;IACxB,wBAAwB;IACxB,4BAA4B;;;;IAI5B,mBAAmB;IACnB,gDAAgD;IAChD,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,uCAAuC;IACvC,6CAA6C;IAC7C,6CAA6C;IAC7C,6CAA6C;;;;;AAKjD;;;AAGA;IACI,uCAAuC;IACvC,gDAAgD;IAChD,4BAA4B;IAC5B,wBAAwB;IACxB,wBAAwB;IACxB,4BAA4B;IAC5B,uBAAuB;IACvB,gCAAgC;IAChC,iCAAiC;IACjC,sCAAsC;IACtC,2BAA2B;IAC3B,wBAAwB;IACxB,6BAA6B;IAC7B,mBAAmB;IACnB,oBAAoB;IACpB,wBAAwB;IACxB,mCAAmC;IACnC,6BAA6B;IAC7B,6CAA6C;IAC7C,gDAAgD;IAChD,6BAA6B;IAC7B,yBAAyB;IACzB,oBAAoB;IACpB,wBAAwB;IACxB,+CAA+C;IAC/C,wBAAwB;IACxB,6CAA6C;IAC7C,wBAAwB;IACxB,gCAAgC;IAChC,4BAA4B;IAC5B,gDAAgD;IAChD,wBAAwB;IACxB,iCAAiC;IACjC,4BAA4B;IAC5B,oBAAoB;IACpB,wBAAwB;IACxB,wBAAwB;IACxB,oBAAoB;IACpB,oBAAoB;IACpB,4BAA4B;IAC5B,wBAAwB;IACxB,wBAAwB;IACxB,mBAAmB;IACnB,wBAAwB;IACxB,mBAAmB;IACnB,oBAAoB;IACpB,oBAAoB;IACpB,yBAAyB;IACzB,6BAA6B;IAC7B,6BAA6B;IAC7B,6BAA6B;IAC7B,oBAAoB;IACpB,iCAAiC;IACjC,+CAA+C;IAC/C,oCAAoC;IACpC,uCAAuC;IACvC,yBAAyB;IACzB,mBAAmB;IACnB;oDACgD;IAChD,8CAA8C;IAC9C,6CAA6C;IAC7C,mBAAmB;IACnB,oBAAoB;IACpB,gCAAgC;IAChC,sBAAsB;IACtB,iDAAiD;IACjD,wBAAwB;IACxB,6BAA6B;IAC7B,4BAA4B;IAC5B,oBAAoB;IACpB,wBAAwB;IACxB,oBAAoB;IACpB,uBAAuB;IACvB,iCAAiC;IACjC,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;;;;;IAKtB,uBAAuB;IACvB,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,gBAAgB;IAChB,eAAe;IACf,sBAAsB;IACtB,gCAAgC;IAChC,6BAA6B;IAC7B,6BAA6B;IAC7B,wBAAwB;IACxB,4BAA4B;IAC5B,uBAAuB;IACvB,gDAAgD;IAChD,6BAA6B;IAC7B,6BAA6B;IAC7B,6BAA6B;KAC5B,2BAA2B;IAC5B,6BAA6B;IAC7B,+CAA+C;IAC/C,6BAA6B;IAC7B,4BAA4B;IAC5B,6BAA6B;IAC7B,+CAA+C;IAC/C,wBAAwB;IACxB,wBAAwB;IACxB,6BAA6B;IAC7B,4BAA4B;IAC5B,wBAAwB;IACxB,wBAAwB;IACxB,yBAAyB;IACzB,wBAAwB;IACxB,wBAAwB;IACxB,4BAA4B;IAC5B,wBAAwB;IACxB,0CAA0C;IAC1C,yBAAyB;IACzB,6BAA6B;IAC7B,6BAA6B;IAC7B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,6BAA6B;IAC7B,6BAA6B;IAC7B,gDAAgD;IAChD,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,yBAAyB;IACzB,8BAA8B;IAC9B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,mDAAmD;IACnD,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,sDAAsD;;IAEtD,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,gDAAgD;IAChD,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,sDAAsD;IACtD,uBAAuB;IACvB,uBAAuB;IACvB,wBAAwB;IACxB,0CAA0C;IAC1C,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,4CAA4C;IAC5C,6BAA6B;IAC7B,uBAAuB;IACvB,oBAAoB;IACpB,mBAAmB;IACnB,wBAAwB;IACxB,oBAAoB;IACpB,wBAAwB;IACxB,wBAAwB;IACxB,4CAA4C;IAC5C,oBAAoB;IACpB,mBAAmB;IACnB,wBAAwB;IACxB,wBAAwB;IACxB,wCAAwC;IACxC,yCAAyC;IACzC,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;IACxB,oBAAoB;IACpB,oBAAoB;IACpB,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;IACxB,oBAAoB;IACpB,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;IACxB,oBAAoB;IACpB,uBAAuB;IACvB,wBAAwB;IACxB,uBAAuB;IACvB,wBAAwB;IACxB,wBAAwB;IACxB,mBAAmB;IACnB,kCAAkC;IAClC,wBAAwB;IACxB,uBAAuB;IACvB,wBAAwB;IACxB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,sCAAsC;IACtC,uBAAuB;IACvB,wBAAwB;IACxB,uBAAuB;IACvB,uBAAuB;;;;IAIvB,wBAAwB;IACxB,wBAAwB;IACxB;4BACwB;IACxB,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;IACxB,4BAA4B;IAC5B,wBAAwB;IACxB,qBAAqB;IACrB,oBAAoB;IACpB,4CAA4C;IAC5C,oBAAoB;IACpB,wBAAwB;IACxB,yBAAyB;IACzB,oBAAoB;IACpB,mBAAmB;IACnB,oBAAoB;IACpB,yBAAyB;IACzB,oBAAoB;IACpB,oBAAoB;IACpB,wBAAwB;IACxB,oBAAoB;IACpB,yBAAyB;IACzB,oBAAoB;IACpB,oBAAoB;IACpB,uBAAuB;IACvB,qBAAqB;IACrB,oBAAoB;IACpB,oBAAoB;IACpB,mBAAmB;IACnB,4CAA4C;IAC5C,uCAAuC;IACvC,uCAAuC;IACvC,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;;;;;;IAMxB,oBAAoB;IACpB,gDAAgD;IAChD,6CAA6C;IAC7C,6BAA6B;IAC7B,6BAA6B;IAC7B,6BAA6B;IAC7B,6BAA6B;IAC7B,6CAA6C;IAC7C,6CAA6C;IAC7C,4CAA4C;;;;;AAKhD","sourcesContent":[":root  {\n    --ice-balck-background: rgb(234, 251, 248);\n    --black-05-background: rgba(0, 0, 0, 0.5); \n    --eeeeef-background: #eeeeef; \n    --f1-background:#f1f1f1;\n    --f5-background:#f5f5f5;\n    --e0e0e0-background: #e0e0e0;\n    --_030303-color:#030303;\n    --f5f5f538-background: #f5f5f538;\n    --f5-chatAdmin-background:#ffffff;\n    --f5-chatAdmin-body-background:#ffffff;\n    --white-background: #ffffff;\n    --_646e8a-color:#646e8a;\n    --_16c098-background:#16c098;\n    --_8a-color:#8a8a8a;\n    --f4-background:#f4f4f4;\n    --f4-chatAdmin-background:#f4f4f4;\n    --_10a37f-background:#10a37f;\n    --_00000036-border:#00000036;\n    --_000000cc-background:#000000cc;\n    --_073f31-background:#073f31;\n    --_d7-background:#d7d7d7;\n    --_5d-color:#5d5d5d;\n    --_16c09821-background:#16c09821;\n    --_0000000a-background: #0000000a;\n    --fe-background:#fefefe;\n    --f1f1f145-background:#f1f1f145;\n    --efefef-background:#efefef;\n    --_00000080-background:#00000080;\n    --_FFFFFF80-background:#FFFFFF60;\n    --_00000020-background:#00000020;\n    --ed-background:#ededed;\n    --_0a785d6d-background:#0a785d6d;\n    --e6fff9-background:#e6fff9;\n    --_1e-color:#1e1e1e;\n    --f9-background:#f9f9f9;\n    --_3c3a3a-color:#3c3a3a;\n    --black-color:black;\n    --_67-color:#676767;\n    --ececf1-background:#ececf1;\n    --f5f5f9-background:#f5f5f9;\n    --ea-background:#eaeaea;\n    --d9d9e3-border:#d9d9e3;\n    --fa-background:#fafafa;\n    --_3-color:#333333;\n    --_3a-color: #3a3a3a;\n    --_71-color:#717171;\n\n    --_b4-color:#b4b4b4;\n    --_0000001a-border:#0000001a; \n    --_00000008-border:#00000008; \n    --_00000000-border:#00000000;\n    --_0d-color:#0d0d0d;\n    --_00000001-background:#00000001; \n    --ececf1-border:#ececf1;\n    --_c1-border:#c1c1c1;\n    --_3a-background:#3a3a3a;\n    --white-color:white;\n    --_e6-color:#e6e6e6;\n    --_52525261-background:#52525261; \n    --_f5f5f569-background:#f5f5f569;\n    --cdece445-background: #cdece445;\n    --e5-border:#e5e5e5;\n    --16c09829-background: #cdece445;\n    --16C097-fill: #16C097;\n    --_16c0982e-background:#16c0982e; \n    --_223f39-color:#223f39;\n    --e4fff9-background:#e4fff9;\n    --f5-border:#f5f5f5;\n    --_38343d-color:#38343d;\n    --_75-color: #757575;\n    --b40e1b-color:#b40e1b;\n    --_00000033-background:#00000033;\n    --_9c9d9f-color:#9c9d9f;\n    --_353740-fill: #353740;\n    --969595-fill: #969595;\n\n    --7c3aed-background: #7c3aed;\n    --111827-background: #111827; \n    --f9fafb-background: #f9fafb; \n    --5d81f5-background: #5d81f5; \n    --3b82f6-background: #3b82f6; \n    --1d4ed8-background: #1d4ed8; \n    --f0fdfa-background: #f0fdfa; \n    --34d399-background: #34d399; \n    --fafbfc-background: #fafbfc; \n    --10b981-background: #10b981; \n    --059669-background: #059669; \n    --196353-background: #196353; \n    --green: #0f0;\n    --cyan: #0ff;\n    --green-again: #0f0;\n    --A8A8A859-background: #A8A8A859; \n    --_233f39-background : #233f39;\n    --_122521-background: #122521;\n    --f3-background:#f3f3f3;\n    --dc3545-background:#dc3545;\n    --c-background:#cccccc;\n    --ffffffdb-background:#ffffffdb; \n    --_0c8e6d-background:#0c8e6d;\n    --_6e6e80-background:#6e6e80;\n    --_5a5a67-background:#5a5a67;\n    --_0d8b6d-background: #0d8b6d;\n    --e9e9e96d-background:#e9e9e96d;\n    --_0b745a-background:#0b745a;\n    --b30634-background:#b30634;\n    --_6f6f81-background:#6f6f81;\n    --_10a37e6a-background:#10a37e6a;\n    --db-background:#dbdbdb;\n    --cf-background:#cfcfcf;\n    --_223f39-background:#223f39;\n    --f3f4f6-background:#f3f4f6;\n    --f6-background:#f6f6f6;\n    --e2-background:#e2e2e2;\n    --_46-background:#464646;\n    --e7-background:#e7e7e7;\n    --e6-background:#e6e6e6;\n    --f8f9fa-background:#f8f9fa;\n    --d9-background:#d9d9d9;\n    --_00000066-background:#00000066;\n    --_c9-background:#c9c9c9;\n    --_11a380-background:#11a380;\n    --_0c6d56-background:#0c6d56;\n    --d8ffea-background:#d8ffea;\n    --effff6-background:#effff6;\n    --f9fbff-background:#f9fbff;\n    --f0f2f8-background:#f0f2f8;\n    --ff5c5c-background:#ff5c5c;\n    --_2b0e50-background:#2b0e50;\n    --_c2f2d3-background:#c2f2d3;\n    --_9bd8b1fd-background:#9bd8b1fd;\n    --f2c6c2-background:#f2c6c2;\n    --f2cfc2-background:#f2cfc2;\n    --f2e3c2-background:#f2e3c2;\n    --c2d8f2-background:#c2d8f2;\n    --d7c5f6-background:#d7c5f6;\n    --f0c2f2-background:#f0c2f2;\n    --ef0-background:#ef0;\n    --dcfce7-background: #dcfce7; \n    --4CAF50-background: #4CAF50; \n    --45a049-background: #45a049; \n    --f8f8f8-background: #f8f8f8; \n    --f7f7f9-background: #f7f7f9; \n    --4a4a4a-background: #4a4a4a; \n    --blue_black-04-background: rgba(0, 163, 163, 0.04);\n    --9e9e9e-background: #9e9e9e; \n    --2563eb-background: #2563eb; \n    --5f64f8-background: #5f64f8;\n    --5054d9-background: #5054d9;\n    --ff7a59-background: #ff7a59;\n    --ee7a01-background: #ee7a01;\n    --ffa927-background: #ffa927;\n    --27a768-background: #27a768;\n    --3cb077-background: #3cb077;\n    --a14689-background: #a14689;\n    --a24689-background: #a24689;\n    --2ad348-background: #2ad348;\n    --5df978-background: #5df978;\n    --e0f2fe-background: #e0f2fe;\n    --fff6d4-background: #fff6d4;\n    --f5f5f538-background-hover: #f5f5f538;\n\n    --622fae-color: #622fae;\n    --6d6d6d-color: #6d6d6d;\n    --202020-color: #202020; \n    --595959-color: #595959; \n    --f59e0b-color: #f59e0b; \n    --334155-color: #334155; \n    --94a3b8-color: #94a3b8; \n    --1e293b-color: #1e293b; \n    --white-stastHeader-color: rgba(255, 255, 255, 0.9);\n    --059669-color: #059669; \n    --64748b-color: #64748b; \n    --0070f3-color: #0070f3; \n    --2e7d32-color: #2e7d32; \n    --_16c098-color:#16c098;\n    --27272a-color: #27272a; \n    --92959865-color: #92959865; \n    --_073f31-color:#073f31;\n    --_6-color:#666666;\n    --_2-color:#222222;\n    --8a0300-color: #8a0300; \n    --c5221f-color: #c5221f; \n    --ff5500-color: #ff5500; \n    --ff9d00-color: #ff9d00; \n    --009f7a-color: #009f7a; \n    --7b7575-color: #7b7575;\n    --red-notification-color: rgb(253, 71, 71);\n    --888-contacts-color: #888888;\n    --292a2b-color: #292a2b;\n    --aaa-color:#aaa;\n    --_9-color:#999999;\n    --_18181b-color:#18181b;\n    --_82-color:#828282;\n    --_1e0045-color:#1e0045;\n    --_2ebc89-color:#2ebc89;\n    --_92959858-color:#92959858;\n    --_1d-color:#1d1d1d;\n    --ec-color:#ececec;\n    --_4f5660-color:#4f5660;\n    --_807d7d-color:#807d7d;\n    --_22222268-color:#22222268;\n    --_2222226d-color:#2222226d;\n    --_09090b-color:#09090b;\n    --_232222-color:#232222;\n    --_71717a-color:#71717a;\n    --_48-color:#484848;\n    --_9b-color:#9b9b9b;\n    --_7e-color:#7e7e7e;\n    --_292d32-color:#292d32;\n    --_8e8eb7-color:#8e8eb7;\n    --_929598-color:#929598;\n    --_374151-color:#374151;\n    --_494e54-color:#494e54;\n    --_1f184b-color:#1f184b;\n    --_2a2e32-color:#2a2e32;\n    --_264f88-color:#264f88;\n    --_808487-color:#808487;\n    --_63-color:#636363;\n    --_5c6c74-color:#5c6c74;\n    --_0c1421-color:#0c1421;\n    --_8897ad-color:#8897ad;\n    --red-color:red;\n    --b5b7c0-color:#b5b7c0;\n    --_233f39-color : #233f39;\n    --d0004b-color:#d0004b;\n    --_3d3c42-color:#3d3c42;\n    --_838485-color:#838485;\n    --a6-color:#a6a6a6;\n    --_00000035-color:#00000035;\n    --_22024b-color:#22024b;\n    --ff4d4f-color:#ff4d4f;\n    --_084437-color:#084437;\n    --btn-chat-background: trasparent;\n    --16a34a-color: #16a34a; \n    --ef4444-color: #ef4444; \n    --dc2626-color: #dc2626; \n    --B0B0B0-color: #B0B0B0; \n    --00a3a3-color: #00a3a3; \n    --6b7280-color: #6b7280; \n    --9ca3af-color: #9ca3af; \n    --818181-color: #818181;\n    --white-unic-color: #FFF;\n    --292929-color: #292929;\n    --8C90A2-color: #8C90A2;\n\n\n    --e5e7eb-border: #e5e7eb;\n    --cecece-border: #cecece; \n    --f8fafc-border: #f8fafc;\n    --f1f5f9-border: #f1f5f9;\n    --e2e8f0-border: #e2e8f0;\n    --grayAccountSettings-border : rgba(228, 228, 228, 0.792);\n    --C11515-color: #C11515;\n    --B3B3B3-border: #B3B3B3; \n    --a194b7-border: #a194b7; \n    --ad8caf-border: #ad8caf; \n    --8c9caf-border: #8c9caf; \n    --8caf98-border: #8caf98; \n    --b6ab92-border: #b6ab92; \n    --af8f8c-border: #af8f8c; \n    --eaecf0-border:#eaecf0;\n    --ccc-border:#ccc;\n    --eb-border:#ebebeb;\n    --_11a3812c-border:#11a3812c;\n    --df-border:#dfdfdf;\n    --ced4da-border:#ced4da;\n    --_10a37f-border: #10a37f;\n    --ca-border:#cacaca;\n    --dc-boder:#dcdcdc;\n    --cb-border:#cbcbcb;\n    --_6f6f81-border:#6f6f81;\n    --e3-border:#e3e3e3;\n    --ef-border:#efefef;\n    --e0e3e6-border:#e0e3e6;\n    --e8-border:#e8e8e8;\n    --_264f88-border:#264f88;\n    --c3-border:#c3c3c3;\n    --e0-border:#e0e0e0;\n    --white-border:#ffffff;\n    --_c9-border:#c9c9c9;\n    --f0-border:#f0f0f0;\n    --d8-border:#d8d8d8;\n    --e-border:#eeeeee;\n    --_11a3813c-border:#11a3813c;\n    --_0000001d-border:#0000001d;\n    --_0000002b-border:#0000002b;\n    --11a38138-border: #11a38138;\n    --cbd5e1-border: #cbd5e1;\n    --dddddd-border: #dddddd; \n    --00000052-border: #00000052;\n\n\n\n    --ac-shadow:#acacac; \n    --customDateInput-shadow: rgba(0, 123, 255, 0.2); \n    --_00000008-shadow:#00000008; \n    --_00000000-shadow:#00000000;\n    --_00000026-shadow:#00000026;\n    --_00000033-shadow:#00000033;\n    --_0000001a-shadow:#0000001a; \n    --black-005-shadow: rgba(0, 0, 0, 0.05); \n    --black-12901-shadow: rgba(16, 185, 129, 0.1); \n    --black-12902-shadow: rgba(16, 185, 129, 0.2); \n    --green-12003-shadow: rgba(16, 185, 129, 0.3); \n\n\n\n\n}\n\n\n[data-theme=\"dark\"] {\n    --ice-balck-background: rgb(15, 45, 43);\n    --black-05-background: rgba(255, 255, 255, 0.12);\n    --eeeeef-background: #1c1c1e; \n    --f1-background: #1a1a1a;\n    --f5-background: #1f1e1e;\n    --e0e0e0-background: #e0e0e0;\n    --_030303-color:#bdbdbd;\n    --f5f5f538-background: #ffffff1A;\n    --f5-chatAdmin-background:#1A1A1A;\n    --f5-chatAdmin-body-background:#212121;\n    --white-background: #121212;\n    --_646e8a-color: #a0abc8;\n    --_16c098-background: #0e5f4f;\n    --_9b-color:#bfbfbf;\n    --_8a-color: #e0e0e0;\n    --f4-background: #1e1e1e;\n    --f4-chatAdmin-background:#F4F4F41C;\n    --_10a37f-background: #0b5e4a;\n    --_00000036-border: rgba(255, 255, 255, 0.15);\n    --_000000cc-background: rgba(255, 255, 255, 0.2);\n    --_073f31-background: #0a5a43;\n    --_d7-background: #2d2d2d;\n    --_5d-color: #cccccc;\n    --_073f31-color: #7ed9b1;\n    --_16c09821-background: rgba(38, 210, 182, 0.2);\n    --_16c098-color: #5ce0c4;\n    --_0000000a-background: rgba(255,255,255,0.4);\n    --fe-background: #121212;\n    --f1f1f145-background: #1e1e1e45;\n    --efefef-background: #2a2a2a;\n    --_00000080-background: rgba(255, 255, 255, 0.5);\n    --ed-background: #3a3a3a;\n    --_0a785d6d-background: #0a785dad;\n    --e6fff9-background: #0e3c36;\n    --_1e-color: #ffffff;\n    --f9-background: #060606;\n    --_3c3a3a-color: #c3c5c5;\n    --black-color: white;\n    --_67-color: #b3b3b3;\n    --ececf1-background: #2c2c2e;\n    --ea-background: #1e1e1e;\n    --d9d9e3-border: #3a3a45;\n    --_6-color: #c0c0c0;\n    --fa-background: #1a1a1a;\n    --_3-color: #e0e0e0;\n    --_3a-color: #e3e3e3;\n    --_71-color: #c0c0c0;\n    --_b4-color-dark: #e0e0e0;\n    --_0000001a-border: #ffffffe6;\n    --_00000008-border: #ffffffed;\n    --_00000000-border: #ffffffff;\n    --_0d-color: #eaeaea;\n    --_00000001-background: #ffffff0a;\n    /* --ececf1-border: rgba(255, 255, 255, 0.2); */\n    --ececf1-border: rgb(58 56 56 / 20%);\n    --_c1-border: rgba(255, 255, 255, 0.15);\n    --_3a-background: #b0b0b0;\n    --white-color:black;\n    --_e6-color: #f0f0rgb(51, 51, 51)\n    --_52525261-background: rgba(255, 255, 255, 0.5);\n    --_f5f5f569-background: rgba(40, 40, 40, 0.41);\n    --cdece445-background: rgba(25, 50, 40, 0.27);\n    --_2-color: #e0e0e0;\n    --e5-border: #2a2a2a;\n    --16c09829-background: #16c09829;\n    --16C097-fill: #0e685d;\n    --_16c0982e-background: rgba(102, 255, 224, 0.18);\n    --_223f39-color: #a8ffde;\n    --_0000001a-shadow: #2221211a;\n    --e4fff9-background: #1a3c36;\n    --f5-border: #3a3a3a;\n    --_38343d-color: #d6d6d6;\n    --_75-color: #dddddd;\n    --b40e1b-color: #ff4c4c;\n    --_ffffff33-background: #ffffff33; \n    --_9c9d9f-color: #c0c1c3;\n    --_353740-fill: #d1d2d7;\n    --969595-fill: #CCCCCC;\n\n\n\n\n    --622fae-color: #5b21b6;\n    --7c3aed-background: #5b21b6; \n    --111827-background: #0f172a; \n    --9e9e9e-background: #2a2a2a; \n    --f9fafb-background: #0f172a; \n    --5d81f5-background: #3b50d6; \n    --3b82f6-background: #2563eb; \n    --1d4ed8-background: #1e40af; \n    --f0fdfa-background: #134e4a; \n    --fafbfc-background: #0f172a; \n    --10b981-background: #047857; \n    --059669-background: #065f46; \n    --196353-background: #0f3f36; \n    --green: #0c8e6d;  \n    --cyan: #088a8a;   \n    --green-again: #0c8e6d;\n    --A8A8A859-background: #FFFFFF59;\n    --_233f39-background: #1b2d2c; \n    --_122521-background: #0a1615;\n    --f3-background: #1e1e1e;\n    --dc3545-background: #a72a30;\n    --c-background: #444444;\n    --ffffffdb-background: rgba(255, 255, 255, 0.15);\n    --_0c8e6d-background: #085b43;\n    --_6e6e80-background: #4a4a59;\n    --_5a5a67-background: #3f3f49;\n     --f5f5f9-background:#333339;\n    --_0d8b6d-background: #086241;\n    --e9e9e96d-background: rgba(233, 233, 233, 0.1);\n    --_0b745a-background: #074a39;\n    --b30634-background: #7a0224;\n    --_6f6f81-background: #474758;\n    --_10a37e6a-background: rgba(16, 163, 126, 0.3);\n    --db-background: #333333;\n    --cf-background: #2f2f2f;\n    --_223f39-background: #1a2b29;\n    --f3f4f6-background: #252525;\n    --f6-background: #2a2a2a;\n    --e2-background: #282828;\n    --_46-background: #1c1c1c;\n    --e7-background: #2f2f2f;\n    --e6-background: #2d2d2d;\n    --f8f9fa-background: #1a1a1a;\n    --d9-background: #3a3a3a;\n    --_00000066-background: rgba(0, 0, 0, 0.7);\n    --_c9-background: #5e5e5e;\n    --_11a380-background: #0d6a5b;\n    --_0c6d56-background: #0a4c3f;\n    --d8ffea-background: #16432b;\n    --effff6-background: #192921;\n    --f9fbff-background: #1c2229;\n    --f0f2f8-background: #21262d;\n    --ff5c5c-background: #b94141;\n    --_2b0e50-background: #180b2e;\n    --_c2f2d3-background: #2a4d3f;\n    --_9bd8b1fd-background: rgba(155, 216, 177, 0.3);\n    --f2c6c2-background: #663c3a;\n    --f2cfc2-background: #6a403c;\n    --f2e3c2-background: #6f5c3a;\n    --c2d8f2-background: #3d4d66;\n    --d7c5f6-background: #4a3a6a;\n    --f0c2f2-background: #6a3a6f;\n    --ef0-background: #53602e;\n    --btn-chat-background: #666666;\n    --dcfce7-background: #166534; \n    --34d399-background: #065f46; \n    --4CAF50-background: #357a38; \n    --45a049-background: #2e7031; \n    --f8f8f8-background: #2a2a2a; \n    --f7f7f9-background: #2c2c2e; \n    --4a4a4a-background: #d9d9d9; \n    --blue_black-04-background: rgba(0, 163, 163, 0.15); \n    --2563eb-background: #1e40af; \n    --5f64f8-background: #3b3ff8; \n    --5054d9-background: #3a3e9f; \n    --ff7a59-background: #cc6247; \n    --ee7a01-background: #b06300; \n    --ffa927-background: #b37f1a; \n    --27a768-background: #1e7c52; \n    --3cb077-background: #2c8b64; \n    --a14689-background: #7a3265; \n    --a24689-background: #883471; \n    --2ad348-background: #1e8a35; \n    --5df978-background: #3b9f55; \n    --fff6d4-background: #4b4a3a;\n    --f5f5f538-background-hover: rgba(255, 255, 255, 0.07);\n\n    --6d6d6d-color: #E0E0E0;\n    --202020-color: #e5e7eb; \n    --595959-color: #d1d5db; \n    --f59e0b-color: #fbbf24; \n    --16a34a-color: #4ade80; \n    --334155-color: #e2e8f0; \n    --94a3b8-color: #e2e8f0; \n    --1e293b-color: #cbd5e1; \n    --white-stastHeader-color: rgba(24, 24, 27, 0.9); \n    --059669-color: #6ee7b7;\n    --64748b-color: #cbd5e1;\n    --0070f3-color: #3399ff; \n    --2e7d32-color: #1b5e20; \n    --grayAccountSettings-border: rgba(100, 100, 100, 0.6);\n    --27272a-color: #3f3f46; \n    --C11515-color: #e94e4e; \n    --B3B3B3-border: #5a5a5a; \n    --92959865-color: rgba(200, 200, 200, 0.2);\n    --8a0300-color: #d94c47; \n    --c5221f-color: #e35b57; \n    --ff5500-color: #ff8a4c; \n    --ff9d00-color: #ffb84d; \n    --009f7a-color: #1ad1a3; \n    --7b7575-color: #BEBEBE;\n    --red-notification-color: rgb(255, 100, 100);\n    --888-contacts-color: #CCCCCC;\n    --292a2b-color: #f1f1f1;\n    --aaa-color: #666666;\n    --_9-color: #7a7a7a;\n    --_18181b-color: #c9c9c9;\n    --_82-color: #a3a3a3;\n    --_1e0045-color: #3a2a6a;\n    --_2ebc89-color: #1c8f68;\n    --_92959858-color: rgba(146, 149, 152, 0.35);\n    --_1d-color: #dcdcdc;\n    --ec-color: #2a2a2a;\n    --_4f5660-color: #9a9fa7;\n    --_807d7d-color: #757575;\n    --_22222268-color: rgba(34, 34, 34, 0.4);\n    --_2222226d-color: rgba(34, 34, 34, 0.43);\n    --_09090b-color: #e5e5e5;\n    --_232222-color: #dddddd;\n    --_71717a-color: #b0b0bb;\n    --_48-color: #a5a5a5;\n    --_7e-color: #a3a3a3;\n    --_292d32-color: #c4c7cc;\n    --_8e8eb7-color: #b1b3c8;\n    --_929598-color: #b5b6b7;\n    --_374151-color: #a0a7b4;\n    --_494e54-color: #9a9fa6;\n    --_1f184b-color: #7c71a2;\n    --_2a2e32-color: #a3a6a8;\n    --_264f88-color: #1d2a5d;\n    --_808487-color: #8e9194;\n    --_63-color: #a3a3a3;\n    --_5c6c74-color: #7c8a91;\n    --_0c1421-color: #1c2232;\n    --_8897ad-color: #9aa3b7;\n    --red-color: #ff6b6b;\n    --b5b7c0-color: #737683;\n    --_233f39-color: #1c2d2a;\n    --d0004b-color: #a0003a;\n    --_3d3c42-color: #a3a6a8;\n    --_838485-color: #7a7a7d;\n    --a6-color: #8c8c8c;\n    --_00000035-color: rgba(0,0,0,0.5);\n    --_22024b-color: #1e1a3a;\n    --ff4d4f-color: #d44c4f;\n    --_084437-color: #4dbf9e;\n    --ef4444-color: #f87171; \n    --dc2626-color: #f87171; \n    --B0B0B0-color: #d4d4d8; \n    --00a3a3-color: #33cccc; \n    --6b7280-color: #d1d5db; \n    --9ca3af-color: #e5e7eb; \n    --00000052-border: rgba(0, 0, 0, 0.32); \n    --818181-color: #c1c1c1;\n    --white-unic-color: #FFF;\n    --292929-color: #d1d5db; \n    --8C90A2-color: #cbd5e1; \n\n\n\n    --e5e7eb-border: #374151; \n    --f8fafc-border: #475569; \n    --f1f5f9-border: #33\n    --e2e8f0-border: #4a5568;\n    --a194b7-border: #c7bbde; \n    --ad8caf-border: #dabbdc; \n    --8c9caf-border: #b7c7de; \n    --8caf98-border: #b7dbc4; \n    --b6ab92-border: #d9cfb6; \n    --af8f8c-border: #d4b3b0; \n    --11a38138-border: #11a38166;\n    --eaecf0-border: #2a2a2a;\n    --ccc-border: #444444;\n    --eb-border: #3a3a3a;\n    --_11a3812c-border: rgba(17, 163, 129, 0.18);\n    --df-border: #383838;\n    --ced4da-border: #3a3a3a;\n    --_10a37f-border: #0b735e;\n    --ca-border: #3a3a3a;\n    --dc-boder: #3a3a3a;\n    --cb-border: #3a3a3a;\n    --_6f6f81-border: #494952;\n    --e3-border: #3b3b3b;\n    --ef-border: #2e2e2e;\n    --e0e3e6-border: #2f2f2f;\n    --e8-border: #3c3c3c;\n    --_264f88-border: #1a2b58;\n    --c3-border: #4a4a4a;\n    --e0-border: #3d3d3d;\n    --white-border: #222222;\n    --_c9-border: #565656;\n    --f0-border: #292929;\n    --d8-border: #393939;\n    --e-border: #3a3a3a;\n    --_11a3813c-border: rgba(17, 163, 129, 0.24);\n    --_0000001d-border: rgba(0, 0, 0, 0.12);\n    --_0000002b-border: rgba(0, 0, 0, 0.17);\n    --cbd5e1-border: #4b5563; \n    --cecece-border: #4b5563; \n    --dddddd-border: #444444; \n\n\n\n\n\n    --ac-shadow: #1a1a1a; \n    --customDateInput-shadow: rgba(0, 123, 255, 0.2); \n    --black-005-shadow: rgba(255, 255, 255, 0.08); \n    --_00000008-shadow: #00000008;\n    --_00000000-shadow: #00000000;\n    --_00000026-shadow: #00000026;\n    --_00000033-shadow: #00000033;\n    --black-12901-shadow: rgba(16, 185, 129, 0.2); \n    --green-12003-shadow: rgba(5, 150, 105, 0.15); \n    --black-12902-shadow: rgba(5, 150, 105, 0.1);\n\n\n\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
